import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $statusColor?: 'success' | 'error' | 'warn' }>`
  width: 79px;
  height: ${({ theme }) => theme.spacing.x6};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.rounded.x25};
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 500;
  ${({ $statusColor }) =>
    $statusColor === 'error'
      ? css`
          background: ${({ theme }) => theme.palette.error10};
          color: ${({ theme }) => theme.palette.error};
        `
      : $statusColor === 'success'
      ? css`
          background: ${({ theme }) => theme.palette.success10};
          color: ${({ theme }) => theme.palette.success};
        `
      : $statusColor === 'warn'
      ? css`
          background: ${({ theme }) => theme.palette.warn};
          color: ${({ theme }) => theme.palette.warn10};
        `
      : null};
`;
